<template>
  <div ref="container" :style="styleObject" />
</template>
<script>
// 可动态加载的组件
// https://github.com/apache/incubator-echarts/blob/master/index.js
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar')
require('echarts/lib/component/legend')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')

// 引入提示框和标题组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')

window.echarts = echarts

export default {
  name: 'PpEchart',
  props: {
    options: Object,
    width: {
      // eslint-disable-next-line
      type: Number | String,
      default: 600
    },
    height: {
      type: Number | String,
      default: 400
    },
    notMerge: {
      type: Boolean,
      default: false
    },
    clickNow: Boolean
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    styleObject() {
      return {
        width: (this.width + 'px').replace('pxpx', 'px'),

        height: (this.height + 'px').replace('pxpx', 'px')
      }
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.container)
    this.setOption()
    this.setOptionCopy()
  },
  methods: {
    setOption(options, notMerge) {
      if (!this.chart) return
      return this.chart.setOption(options || this.options, notMerge)
    },
    setOptionCopy(options, notMerge) {
      this.chart.dispose()
      this.chart = echarts.init(this.$refs.container)
      if (!this.chart) return
      return this.chart.setOption(options || this.options, notMerge)
    }
  }
}
</script>
<style lang="scss" scoped>
canvas {
  width: 100%;
}
</style>

